


















































































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import "@fullcalendar/core/vdom";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import listPlugin from "@fullcalendar/list";
import solicitudesWorkflowModule from "@/store/modules/solicitudes-workflow-module";
import usuarioModule from "@/store/modules/usuario-module";
import { MessageService } from "@/shared/services/message-service";
import AgendaSupportGuide from "@/components/Assistant/AgendaSupportGuide.vue";
import AgendaGlobalToolbar from "./components/AgendaGlobalToolbar.vue";
import AgendaCalendarView from "./components/AgendaCalendarView.vue";
import AgendaGesdenPanel from "./components/AgendaGesdenPanel.vue";
import AgendaDetalleDrawer from "./components/AgendaDetalleDrawer.vue";

@Component({
  name: "AgendaCalendarManager",
  components: {
    FullCalendar,
    AgendaSupportGuide,
    AgendaGlobalToolbar,
    AgendaCalendarView,
    AgendaGesdenPanel,
    AgendaDetalleDrawer,
  },
})
export default class AgendaCalendarManager extends Vue {
  private static readonly ADD_MANUAL_WARNING_KEY =
    "agenda:add-manual:warning:hide";
  // --- Datos principales ---
  public rows: any[] = [];
  public catalogos: any = {
    centros: [],
    servicios: [],
    canales: [],
    estados: [],
  };
  public pacientes: any[] = [];

  public filters: any = {
    id_centro: null,
    fecha_desde: "",
    fecha_hasta: "",
    take: 1000,
  };
  // --- Estado de la UI ---
  public loading = false;
  public drawerVisible = false;
  public drawerLoading = false;
  public drawerItem: any = null;
  public modalGesden = false;
  public modalGesdenItem: any = null;
  public savingAction = false;
  public savingDrawer = false;
  public supportGuideVisible = false;
  public centroFijado = false;
  public currentView = "timeGridWeek";
  public calendarTitle = "";
  public showManualWarningDialog = false;
  public dontShowManualWarningAgain = false;
  public drawerForm: any = this.defaultDrawerForm();
  public drawerPacienteBase: any = null;
  // --- Popover nueva cita ---
  public popover = {
    visible: false,
    pos: { x: 0, y: 0 },
    horaInicio: "",
    horaFin: "",
  };
  public createForm: any = this.defaultCreateForm();
  public searchPaciente = "";
  public creandoPaciente = false;
  public saving = false;
  // --- Modal Gesden ---
  public copiedField: string | null = null;
  // --- Lifecycle ---
  public async mounted() {
    await this.bootstrap();
    this.bindAiEvents();
    this._loadAddManualWarningPreference();
    this.$nextTick(() => {
      this.updateCalendarTitle();
      this._irACitaDesdeQuery();
    });
  }

  public beforeDestroy() {
    this.unbindAiEvents();
  }

  public async bootstrap() {
    this.loading = true;
    try {
      // Cargar el usuario actual si todavÃ­a no estÃ¡ en el store
      if (!usuarioModule.mi_usuario || !usuarioModule.mi_usuario.id) {
        await usuarioModule.getmiusuario();
      }
      const centroUsuario =
        usuarioModule.mi_usuario && usuarioModule.mi_usuario.id_centro;
      if (centroUsuario) {
        this.filters.id_centro = centroUsuario;
        this.centroFijado = true;
      }

      const results = await Promise.all([
        solicitudesWorkflowModule.getCatalogosAdmin(),
        solicitudesWorkflowModule.getTableroAdmin({
          id_centro: this.filters.id_centro,
          take: 1000,
        }),
      ]);
      const catRes: any = results[0];
      const tabRes: any = results[1];
      this.catalogos =
        catRes && catRes.data
          ? catRes.data
          : { centros: [], servicios: [], canales: [], estados: [] };
      this.rows =
        tabRes && tabRes.data && tabRes.data.rows ? tabRes.data.rows : [];

      // Carga no crítica: lista de pacientes para autocomplete
      // Se hace después del Promise.all para que un fallo aquí no bloquee la agenda
      solicitudesWorkflowModule
        .buscarPacientes("")
        .then((pacRes: any) => {
          this.pacientes = pacRes && pacRes.data ? pacRes.data : [];
        })
        .catch(() => {
          this.pacientes = [];
        });
    } catch (e) {
      MessageService.alert(
        "Error",
        "No se pudo cargar la agenda",
        MessageService.TypeError,
      );
    } finally {
      this.loading = false;
    }
  }
  // --- Computed ---
  public get isMobile(): boolean {
    return window.innerWidth < 768;
  }

  public get aiContextAgenda(): string {
    return JSON.stringify({
      pantalla: "AgendaCalendarManager",
      objetivo:
        "Gestionar citas del calendario, crear citas manuales y ejecutar acciones de workflow",
      flujo_recomendado: [
        "Pulsa 'Añadir manualmente' para crear una cita sin seleccionar hueco",
        "Rellena paciente, servicio, canal y horario",
        "Abre una cita para editar campos y aplicar acciones rÃ¡pidas",
      ],
      selectores: {
        add_manual: "[data-ai-id='agenda-add-manual']",
        soporte: "[data-ai-id='agenda-support']",
      },
    });
  }

  public get centrosItems(): any[] {
    return (this.catalogos.centros || []).map((c: any) => ({
      value: c.id,
      text: c.nombre,
    }));
  }

  public get canalesItems(): any[] {
    return (this.catalogos.canales || []).map((c: any) => ({
      value: c.codigo,
      text: c.nombre,
    }));
  }

  public get canalesDrawerItems(): any[] {
    return (this.catalogos.canales || []).map((c: any) => ({
      value: c.id,
      text: c.nombre,
    }));
  }

  public get serviciosAgrupados(): any[] {
    return (this.catalogos.servicios || []).map((s: any) => ({
      id: s.id,
      nombre: s.servicio || s.nombre || "",
      codigo: s.codigo_elegido || "",
      tiempo_minutos: s.tiempo_minutos,
      descripcion: s.descripcion || "",
    }));
  }

  public get pacientesFiltrados(): any[] {
    const q = (this.searchPaciente || "").toLowerCase().trim();
    if (!q) return this.pacientes.slice(0, 20).map(this.mapPaciente);
    return this.pacientes
      .filter((p: any) => {
        const blob = [p.nombre, p.apellidos, p.telefono, p.email, p.documento]
          .join(" ")
          .toLowerCase();
        return blob.indexOf(q) !== -1;
      })
      .slice(0, 20)
      .map(this.mapPaciente);
  }

  public get bandejaGesden(): any[] {
    return this.rows.filter((x: any) =>
      [
        "pendiente",
        "enviada_gesden",
        "cancelacion_pendiente_gesden",
        "reagendado_pendiente_gesden",
      ].includes(x.estado_codigo),
    );
  }
  // --- Computed ---
  public get drawerSolicitud(): any {
    return this.drawerItem && this.drawerItem.solicitud
      ? this.drawerItem.solicitud
      : {};
  }

  public get calendarEvents(): any[] {
    return this.rows.map((x: any) => {
      const color = this.stateColor(x.estado_codigo);
      return {
        id: String(x.id),
        title:
          (x.paciente_nombre || "Sin nombre") +
          " - " +
          (x.servicio_codigo || x.servicio_nombre || "") +
          (x.nombre_profesional ? " Â· " + x.nombre_profesional : ""),
        start: x.fecha_hora_inicio_solicitada,
        end: x.fecha_hora_fin_solicitada,
        backgroundColor: color,
        borderColor: color,
        textColor: this.stateTextColor(x.estado_codigo),
        extendedProps: { row: x },
      };
    });
  }

  public get calendarOptions(): any {
    return {
      plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin, listPlugin],
      initialView: this.currentView,
      locale: "es",
      headerToolbar: false,
      editable: true,
      eventStartEditable: false,
      selectable: true,
      selectMirror: true,
      slotMinTime: "08:00:00",
      slotMaxTime: "21:00:00",
      allDaySlot: false,
      height: "100%",
      expandRows: true,
      nowIndicator: true,
      events: this.calendarEvents,
      select: this.onCalendarSelect,
      eventClick: this.onEventClick,
      eventResize: this.onEventResize,
      eventDidMount: this.onEventDidMount,
      datesSet: this.onDatesSet,
    };
  }

  public get puedeGuardar(): boolean {
    if (this.creandoPaciente) {
      return !!(
        this.createForm.nombre &&
        this.createForm.telefono &&
        this.createForm.id_servicio &&
        this.createForm.fecha_hora_inicio &&
        this.createForm.fecha_hora_fin
      );
    }
    return !!(
      this.createForm.id_servicio &&
      this.createForm.fecha_hora_inicio &&
      this.createForm.fecha_hora_fin
    );
  }

  public get puedeGuardarDrawer(): boolean {
    return !!(
      this.drawerForm.id &&
      this.drawerForm.id_centro &&
      this.drawerForm.id_servicio &&
      this.drawerForm.id_canal_entrada &&
      this.drawerForm.nombre &&
      this.drawerForm.telefono &&
      this.drawerForm.fecha_hora_inicio &&
      Number(this.drawerForm.duracion_minutos) > 0
    );
  }

  public get drawerCentroText(): string {
    const centro = (this.catalogos.centros || []).find(
      (c: any) => c.id === Number(this.drawerForm.id_centro),
    );
    return centro ? centro.nombre : "";
  }

  public get drawerServicioText(): string {
    const servicio = (this.catalogos.servicios || []).find(
      (s: any) => s.id === Number(this.drawerForm.id_servicio),
    );
    return servicio ? servicio.servicio || servicio.nombre || "" : "";
  }

  public get drawerCanalText(): string {
    const canal = (this.catalogos.canales || []).find(
      (c: any) => c.id === Number(this.drawerForm.id_canal_entrada),
    );
    return canal ? canal.nombre : "";
  }

  public get estadoInlineStyle(): any {
    const color = this.stateColor(this.drawerSolicitud.estado_codigo || "");
    return {
      borderLeft: "4px solid " + color,
    };
  }

  public get camposGesden(): any[] {
    if (!this.modalGesdenItem) return [];
    const item = this.modalGesdenItem;
    const campos = [
      {
        field: "nombre",
        label: "Nombre",
        value: (
          (item.paciente_nombre || "") +
          " " +
          (item.paciente_apellidos || "")
        ).trim(),
      },
      {
        field: "telefono",
        label: "Telefono",
        value: item.paciente_telefono || "",
      },
      { field: "email", label: "Email", value: item.paciente_email || "" },
      {
        field: "servicio",
        label: "Servicio",
        value: item.servicio_nombre || "",
      },
      { field: "motivo", label: "Motivo", value: item.motivo_paciente || "" },
      {
        field: "horario",
        label: "Fecha y hora",
        value: this.formatDateTime(item.fecha_hora_inicio_solicitada),
      },
      {
        field: "duracion",
        label: "Duracion (min)",
        value: String(item.duracion_minutos || ""),
      },
      {
        field: "notas",
        label: "Notas internas",
        value: item.notas_internas || "",
      },
    ];
    return campos.filter((c: any) => c.value);
  }

  public get popoverStyle(): any {
    if (this.isMobile) return {};
    return {
      position: "fixed",
      left: Math.min(this.popover.pos.x, window.innerWidth - 360) + "px",
      top: Math.min(this.popover.pos.y, window.innerHeight - 500) + "px",
      zIndex: 999,
      width: "340px",
    };
  }
  // --- Watchers ---
  @Watch("createForm.id_servicio")
  public onServicioChange(id: number) {
    if (!id) return;
    const svc = (this.catalogos.servicios || []).find((s: any) => s.id === id);
    if (svc && this.createForm.fecha_hora_inicio) {
      const d = new Date(this.createForm.fecha_hora_inicio);
      d.setMinutes(d.getMinutes() + (svc.tiempo_minutos || 30));
      this.createForm.fecha_hora_fin = d.toISOString().substring(0, 16);
      this.popover.horaFin = d.toISOString().substring(11, 16);
    }
  }

  @Watch("currentView")
  public onViewChange(v: string) {
    const api = this.getCalendarApi();
    if (api) {
      api.changeView(v);
    }
    this.updateCalendarTitle();
  }

  @Watch("searchPaciente")
  public async onSearchPaciente(q: string) {
    if (!q || q.length < 2) return;
    try {
      const res: any = await solicitudesWorkflowModule.buscarPacientes(q);
      if (res && res.data) {
        this.pacientes = res.data;
      }
    } catch (e) {
      // silencioso
    }
  }

  @Watch("drawerForm.fecha_hora_inicio")
  public onDrawerInicioChange(v: string) {
    if (!v || !this.drawerForm.duracion_minutos) return;
    const inicio = new Date(v);
    if (isNaN(inicio.getTime())) return;
    inicio.setMinutes(
      inicio.getMinutes() + Number(this.drawerForm.duracion_minutos || 30),
    );
    this.drawerForm.fecha_hora_fin = this.toDateTimeLocal(inicio.toISOString());
  }

  @Watch("drawerForm.duracion_minutos")
  public onDrawerDuracionChange(v: number) {
    if (!v || !this.drawerForm.fecha_hora_inicio) return;
    const inicio = new Date(this.drawerForm.fecha_hora_inicio);
    if (isNaN(inicio.getTime())) return;
    inicio.setMinutes(inicio.getMinutes() + Number(v || 30));
    this.drawerForm.fecha_hora_fin = this.toDateTimeLocal(inicio.toISOString());
  }
  // --- Helpers calendario ---
  private getCalendarApi(): any {
    const ref = this.$refs.calendarView as any;
    return ref && ref.getCalendarApi ? ref.getCalendarApi() : null;
  }

  public calPrev() {
    const api = this.getCalendarApi();
    if (api) {
      api.prev();
    }
    this.updateCalendarTitle();
  }

  public calNext() {
    const api = this.getCalendarApi();
    if (api) {
      api.next();
    }
    this.updateCalendarTitle();
  }

  public calToday() {
    const api = this.getCalendarApi();
    if (api) {
      api.today();
    }
    this.updateCalendarTitle();
  }

  private updateCalendarTitle() {
    this.$nextTick(() => {
      const api = this.getCalendarApi();
      this.calendarTitle =
        api && api.view && api.view.title ? api.view.title : "";
    });
  }

  public onDatesSet() {
    this.updateCalendarTitle();
  }

  private bindAiEvents() {
    this.$root.$on("ai:click", this.onAiClick);
    this.$root.$on("ai:highlight", this.onAiHighlight);
  }

  private unbindAiEvents() {
    this.$root.$off("ai:click", this.onAiClick);
    this.$root.$off("ai:highlight", this.onAiHighlight);
  }

  private onAiClick(target: string) {
    if (!target) return;
    const normalized = String(target).trim();
    const selector =
      normalized.indexOf("[") >= 0 || normalized.indexOf(".") >= 0
        ? normalized
        : "[data-ai-id='" + normalized + "']";

    const el = document.querySelector(selector) as HTMLElement;
    if (el && el.click) {
      el.click();
    }
  }

  private onAiHighlight(target: string) {
    if (!target) return;
    const normalized = String(target).trim();
    const selector =
      normalized.indexOf("[") >= 0 || normalized.indexOf(".") >= 0
        ? normalized
        : "[data-ai-id='" + normalized + "']";

    const el = document.querySelector(selector) as HTMLElement;
    if (!el) return;
    el.classList.add("ai-highlight");
    setTimeout(() => el.classList.remove("ai-highlight"), 1800);
    if (el.scrollIntoView) {
      el.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }
  // --- Eventos FullCalendar ---
  public onCalendarSelect(info: any) {
    const jsEvent = info.jsEvent || {};
    const x =
      jsEvent.clientX !== undefined ? jsEvent.clientX : window.innerWidth / 2;
    const y =
      jsEvent.clientY !== undefined ? jsEvent.clientY : window.innerHeight / 2;
    this.popover.pos = { x: x, y: y };
    this.popover.horaInicio = info.startStr
      ? info.startStr.substring(11, 16)
      : "";
    this.popover.horaFin = info.endStr ? info.endStr.substring(11, 16) : "";
    this.createForm = this.defaultCreateForm();
    this.createForm.fecha_hora_inicio = info.startStr
      ? info.startStr.substring(0, 16)
      : "";
    this.createForm.fecha_hora_fin = info.endStr
      ? info.endStr.substring(0, 16)
      : "";
    this.creandoPaciente = false;
    this.searchPaciente = "";
    this.popover.visible = true;
    this.$nextTick(() => {
      const el = this.$refs.popoverEl as HTMLElement;
      if (el && el.focus) {
        el.focus();
      }
    });
  }

  public abrirNuevaCitaManual() {
    const inicio = this.getSiguienteBloqueHorario();
    const fin = new Date(inicio);
    fin.setMinutes(fin.getMinutes() + 30);

    this.popover.pos = {
      x: Math.round(window.innerWidth * 0.55),
      y: Math.round(window.innerHeight * 0.2),
    };
    this.createForm = this.defaultCreateForm();
    this.createForm.fecha_hora_inicio = this.toDateTimeLocal(
      inicio.toISOString(),
    );
    this.createForm.fecha_hora_fin = this.toDateTimeLocal(fin.toISOString());
    this.popover.horaInicio = this.createForm.fecha_hora_inicio.substring(
      11,
      16,
    );
    this.popover.horaFin = this.createForm.fecha_hora_fin.substring(11, 16);
    this.creandoPaciente = true;
    this.searchPaciente = "";
    this.popover.visible = true;
    this.$nextTick(() => {
      const el = this.$refs.popoverEl as HTMLElement;
      if (el && el.focus) el.focus();
    });
  }

  public onClickAddManual() {
    if (this._shouldSkipAddManualWarning()) {
      this.abrirNuevaCitaManual();
      return;
    }
    this.showManualWarningDialog = true;
  }

  public confirmarAddManualDesdeAviso() {
    if (this.dontShowManualWarningAgain) {
      localStorage.setItem(AgendaCalendarManager.ADD_MANUAL_WARNING_KEY, "1");
    }
    this.showManualWarningDialog = false;
    this.abrirNuevaCitaManual();
  }

  public abrirSoporteGuia() {
    this.supportGuideVisible = true;
  }

  public abrirSoporteAgenda() {
    this.supportGuideVisible = false;
    this.$root.$emit("ai-assistant:open", {
      message:
        "Estoy en Agenda. ExplÃ­came paso a paso quÃ© va a pasar al crear una cita manual, editar una cita, y usar acciones rÃ¡pidas. DespuÃ©s guÃ­ame con clicks.",
    });
  }

  public async onEventClick(info: any) {
    const row = info.event.extendedProps.row;
    if (row.estado_codigo === "enviada_gesden") {
      this.modalGesdenItem = row;
      this.modalGesden = true;
    } else {
      this.drawerVisible = true;
      this.drawerLoading = true;
      this.drawerItem = null;
      try {
        const res: any = await solicitudesWorkflowModule.getDetalleAdmin(
          row.id,
        );
        this.drawerItem = res && res.data ? res.data : null;
        await this.cargarDrawerForm();
      } catch (e) {
        MessageService.alert(
          "Error",
          "No se pudo cargar el detalle",
          MessageService.TypeError,
        );
        this.drawerVisible = false;
      } finally {
        this.drawerLoading = false;
      }
    }
  }

  public async onEventResize(info: any) {
    await this.actualizarFechasEvento(
      info,
      "Duracion actualizada",
      "No se pudo actualizar la duracion",
    );
  }

  private async actualizarFechasEvento(
    info: any,
    successMsg: string,
    errorMsg: string,
  ) {
    try {
      const start: Date = info.event.start;
      const end: Date = info.event.end || info.event.start;
      const durMin =
        Math.round((end.getTime() - start.getTime()) / 60000) || 30;
      await solicitudesWorkflowModule.actualizarFechasSolicitud({
        id: Number(info.event.id),
        fecha_hora_inicio: start.toISOString(),
        fecha_hora_fin: end.toISOString(),
        duracion_minutos: durMin,
      });
      const row = this.rows.find((r: any) => r.id === Number(info.event.id));
      if (row) {
        row.fecha_hora_inicio_solicitada = start.toISOString();
        row.fecha_hora_fin_solicitada = end.toISOString();
        row.duracion_minutos = durMin;
      }
      MessageService.toast(successMsg);
    } catch (e) {
      info.revert();
      MessageService.alert("Error", errorMsg, MessageService.TypeError);
    }
  }

  public onEventDidMount(info: any) {
    // Necesario para que irAEvento pueda localizar el elemento en el DOM
    info.el.setAttribute("data-event-id", info.event.id);

    const row = info.event.extendedProps.row;
    const codigo =
      row && row.estado_codigo ? row.estado_codigo.toLowerCase() : "";
    if (codigo === "enviada_gesden") {
      info.el.style.backgroundImage =
        "repeating-linear-gradient(45deg, transparent, transparent 4px, rgba(0,0,0,0.15) 4px, rgba(0,0,0,0.15) 8px)";
    }
    if (
      codigo === "cancelada" ||
      codigo === "rechazada" ||
      codigo === "expirada"
    ) {
      const titleEl = info.el.querySelector(".fc-event-title");
      if (titleEl) {
        titleEl.style.textDecoration = "line-through";
      }
      info.el.style.opacity = "0.6";
    }
    if (codigo === "conflicto" || codigo === "fallida_gesden") {
      info.el.style.borderLeft = "4px solid #EF4444";
    }
    if (codigo === "pendiente") {
      info.el.style.borderLeft = "4px solid #D97706";
    }
  }
  // --- Bandeja Gesden ---
  public bandejaCss(estado: string): string {
    const cssMap: Record<string, string> = {
      cancelacion_pendiente_gesden: "bandeja-item bandeja-item--cancelacion",
      reagendado_pendiente_gesden:  "bandeja-item bandeja-item--reagendado",
      pendiente:                    "bandeja-item bandeja-item--pendiente",
      enviada_gesden:               "bandeja-item bandeja-item--enviada",
    };
    return cssMap[estado] || "bandeja-item";
  }

  public irAEvento(item: any) {
    const fecha = (item.fecha_hora_inicio_solicitada || "").substring(0, 10);
    const highlightId = String(item.id);
    if (fecha) {
      const api = this.getCalendarApi();
      if (api) {
        api.gotoDate(fecha);
      }
      this.updateCalendarTitle();
    }
    // FullCalendar re-renders asynchronously after gotoDate; wait for DOM update.
    // Se usa style.animation directamente porque el <style> es scoped y las clases
    // de Vue no aplican a elementos generados por FullCalendar.
    setTimeout(() => {
      const el = document.querySelector(
        '[data-event-id="' + highlightId + '"]',
      ) as HTMLElement;
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "center" });
        el.style.animation = "flashEvent 2s ease-out";
        el.style.position = "relative";
        el.style.zIndex = "5";
        setTimeout(() => {
          el.style.animation = "";
          el.style.position = "";
          el.style.zIndex = "";
        }, 2100);
      }
    }, 300);
  }

  private async _irACitaDesdeQuery() {
    const { fecha, cita_id } = this.$route.query as Record<string, string>;
    if (!fecha && !cita_id) {
      return;
    }

    // Limpiar query params antes de actuar para no repetir si el usuario recarga
    this.$router.replace({ query: {} }).catch(() => {
      /* misma ruta */
    });

    if (fecha) {
      const api = this.getCalendarApi();
      if (api) {
        api.gotoDate(fecha);
      }
      this.updateCalendarTitle();
    }

    if (cita_id) {
      const id = Number(cita_id);
      // Flash sobre el evento en el calendario (mismo patrón que irAEvento)
      setTimeout(() => {
        const el = document.querySelector(
          '[data-event-id="' + cita_id + '"]',
        ) as HTMLElement;
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "center" });
          el.style.animation = "flashEvent 2s ease-out";
          el.style.position = "relative";
          el.style.zIndex = "5";
          setTimeout(() => {
            el.style.animation = "";
            el.style.position = "";
            el.style.zIndex = "";
          }, 2100);
        }
      }, 300);

      // Abrir el drawer de detalle igual que onEventClick
      this.drawerVisible = true;
      this.drawerLoading = true;
      this.drawerItem = null;
      try {
        const res: any = await solicitudesWorkflowModule.getDetalleAdmin(id);
        this.drawerItem = res && res.data ? res.data : null;
        await this.cargarDrawerForm();
      } catch (e) {
        MessageService.alert(
          "Error",
          "No se pudo cargar el detalle",
          MessageService.TypeError,
        );
        this.drawerVisible = false;
      } finally {
        this.drawerLoading = false;
      }
    }
  }
  // --- Filtros ---
  public async onFiltersChange() {
    await this.refreshTablero();
  }

  public async onChangeCentroToolbar(idCentro: number | null) {
    this.filters.id_centro = idCentro;
    await this.refreshTablero();
  }

  public async refreshTablero() {
    this.loading = true;
    try {
      const res: any = await solicitudesWorkflowModule.getTableroAdmin({
        id_centro: this.filters.id_centro,
        take: 1000,
      });
      this.rows = res && res.data && res.data.rows ? res.data.rows : [];
    } catch (e) {
      MessageService.alert(
        "Error",
        "No se pudieron actualizar las citas",
        MessageService.TypeError,
      );
    } finally {
      this.loading = false;
    }
  }
  // --- Popover nueva cita ---
  public cerrarPopover() {
    this.popover.visible = false;
    this.creandoPaciente = false;
    this.searchPaciente = "";
  }

  public onPacienteSelected(id: number | null) {
    if (!id) return;
    const p = this.pacientes.find((pac: any) => pac.id === id);
    if (p) {
      this.createForm.nombre = p.nombre;
      this.createForm.apellidos = p.apellidos;
      this.createForm.telefono = p.telefono;
      this.createForm.email = p.email || "";
    }
  }

  public onToggleCreandoPaciente(v: boolean) {
    if (v) {
      this.createForm.id_paciente_lead = null;
    }
  }

  public async guardarCita() {
    this.saving = true;
    try {
      const payload: any = {
        id_centro: this.filters.id_centro || null,
        id_servicio: Number(this.createForm.id_servicio),
        fecha_hora_inicio_solicitada: this.toIsoDate(
          this.createForm.fecha_hora_inicio,
        ),
        duracion_minutos: this.calcDuracion(),
        canal_codigo: this.createForm.canal_codigo || "telefono",
        estado_codigo: "pendiente",
        motivo_paciente: this.createForm.motivo_paciente || "",
        notas_internas: this.createForm.notas_internas || "",
        observaciones_admin: "",
        nombre: this.createForm.nombre || "",
        apellidos: this.createForm.apellidos || "",
        telefono: this.createForm.telefono || "",
        email: this.createForm.email || "",
        fecha_nacimiento: null,
        documento: "",
      };
      if (this.createForm.id_paciente_lead) {
        payload.id_paciente_lead = Number(this.createForm.id_paciente_lead);
      }
      await solicitudesWorkflowModule.crearAdmin(payload);
      MessageService.toast("Cita creada correctamente");
      this.cerrarPopover();
      await this.refreshTablero();
    } catch (e) {
      MessageService.alert(
        "Error",
        "No se pudo crear la cita",
        MessageService.TypeError,
      );
    } finally {
      this.saving = false;
    }
  }
  // --- Drawer acciones ---
  public async ejecutarAccion(id: number, accion: string) {
    this.savingAction = true;
    try {
      await solicitudesWorkflowModule.accionAdmin({
        id,
        accion: { accion: accion, comentario: "" },
      });
      MessageService.toast("Accion aplicada correctamente");
      this.mostrarRecordatorioGesden(accion);
      this.drawerVisible = false;
      await this.refreshTablero();
    } catch (e) {
      MessageService.alert(
        "Error",
        "No se pudo aplicar la accion",
        MessageService.TypeError,
      );
    } finally {
      this.savingAction = false;
    }
  }

  public async guardarEdicionDrawer() {
    if (!this.puedeGuardarDrawer) return;
    this.savingDrawer = true;
    try {
      const inicioIso = this.toIsoDate(this.drawerForm.fecha_hora_inicio);
      const finIso = this.drawerForm.fecha_hora_fin
        ? this.toIsoDate(this.drawerForm.fecha_hora_fin)
        : this.sumarMinutosIso(
            inicioIso,
            Number(this.drawerForm.duracion_minutos || 30),
          );

      const payloadSolicitud: any = {
        ...this.drawerSolicitud,
        id: Number(this.drawerForm.id),
        id_centro: Number(this.drawerForm.id_centro),
        id_servicio: Number(this.drawerForm.id_servicio),
        id_canal_entrada: Number(this.drawerForm.id_canal_entrada),
        fecha_hora_inicio_solicitada: inicioIso,
        fecha_hora_fin_solicitada: finIso,
        fecha_solicitada: inicioIso,
        hora_solicitada: this.timeSpanFromIso(inicioIso),
        duracion_minutos: Number(this.drawerForm.duracion_minutos || 30),
        motivo_paciente: this.drawerForm.motivo_paciente || "",
        notas_internas: this.drawerForm.notas_internas || "",
        observaciones_admin: this.drawerForm.observaciones_admin || "",
      };

      const payloadPaciente: any = {
        ...(this.drawerPacienteBase || {}),
        id: Number(this.drawerForm.id_paciente_lead),
        nombre: this.drawerForm.nombre || "",
        apellidos: this.drawerForm.apellidos || "",
        telefono: this.drawerForm.telefono || "",
        email: this.drawerForm.email || "",
        documento: this.drawerForm.documento || "",
      };

      await Promise.all([
        solicitudesWorkflowModule.actualizarSolicitudAdmin({
          id: Number(this.drawerForm.id),
          solicitud: payloadSolicitud,
        }),
        solicitudesWorkflowModule.actualizarPacienteLead({
          id: Number(this.drawerForm.id_paciente_lead),
          paciente: payloadPaciente,
        }),
      ]);

      const detRes: any = await solicitudesWorkflowModule.getDetalleAdmin(
        Number(this.drawerForm.id),
      );
      this.drawerItem = detRes && detRes.data ? detRes.data : this.drawerItem;
      await this.cargarDrawerForm();
      await this.refreshTablero();
      MessageService.toast("Cambios guardados");

      // Enviar WhatsApp al paciente informando de la modificación (fire-and-forget)
      solicitudesWorkflowModule
        .notificarModificacionWhatsapp(Number(this.drawerForm.id))
        .catch(() => { /* silencioso */ });

      // Recordatorio GESDEN
      MessageService.alert(
        "Recuerda actualizar en GESDEN",
        "Aplica esta misma modificación en GESDEN si la cita ya estaba registrada allí.",
        MessageService.TypeWarning,
      );
    } catch (e) {
      MessageService.alert(
        "Error",
        "No se pudieron guardar los cambios",
        MessageService.TypeError,
      );
    } finally {
      this.savingDrawer = false;
    }
  }
  // --- Modal Gesden ---
  public async copiarAlPortapapeles(field: string, value: string) {
    try {
      await navigator.clipboard.writeText(value || "");
      this.copiedField = field;
      setTimeout(() => {
        this.copiedField = null;
      }, 2000);
    } catch (e) {
      MessageService.toast("No se pudo copiar al portapapeles");
    }
  }

  public async marcarInsertadaGesden() {
    if (!this.modalGesdenItem) return;
    this.savingAction = true;
    try {
      await solicitudesWorkflowModule.accionAdmin({
        id: this.modalGesdenItem.id,
        accion: { accion: "marcar_insertada_gesden", comentario: "" },
      });
      const row = this.rows.find((r: any) => r.id === this.modalGesdenItem.id);
      if (row) {
        row.estado_codigo = "insertada_gesden";
      }
      this.modalGesden = false;
      MessageService.toast("Insertada en Gesden");
      this.mostrarRecordatorioGesden("marcar_insertada_gesden");
    } catch (e) {
      MessageService.alert(
        "Error",
        "No se pudo marcar como insertada",
        MessageService.TypeError,
      );
    } finally {
      this.savingAction = false;
    }
  }

  public async marcarConflicto() {
    if (!this.modalGesdenItem) return;
    this.savingAction = true;
    try {
      await solicitudesWorkflowModule.accionAdmin({
        id: this.modalGesdenItem.id,
        accion: { accion: "marcar_conflicto", comentario: "" },
      });
      const row = this.rows.find((r: any) => r.id === this.modalGesdenItem.id);
      if (row) {
        row.estado_codigo = "conflicto";
      }
      this.modalGesden = false;
      MessageService.toast("Marcado como conflicto");
      this.mostrarRecordatorioGesden("marcar_conflicto");
    } catch (e) {
      MessageService.alert(
        "Error",
        "No se pudo marcar el conflicto",
        MessageService.TypeError,
      );
    } finally {
      this.savingAction = false;
    }
  }

  private mostrarRecordatorioGesden(accion: string) {
    const accionNormalizada = (accion || "").toLowerCase();
    if (accionNormalizada === "marcar_insertada_gesden") {
      MessageService.alert(
        "Atención",
        "Recuerda insertarla en GESDEN.",
        MessageService.TypeWarning,
      );
      return;
    }
    if (
      accionNormalizada.includes("cancelar") ||
      accionNormalizada.includes("cancelad")
    ) {
      MessageService.alert(
        "Atención",
        "Recuerda cancelar en GESDEN si esta alli dada de alta.",
        MessageService.TypeWarning,
      );
      return;
    }
    if (accionNormalizada.includes("reagendar")) {
      MessageService.alert(
        "Atención",
        "Recuerda reagendar en GESDEN si esta alli dada de alta.",
        MessageService.TypeWarning,
      );
      return;
    }
    if (accionNormalizada.includes("marcar_conflicto")) {
      MessageService.alert(
        "Atención",
        "Recuerda revisar el conflicto en GESDEN.",
        MessageService.TypeWarning,
      );
      return;
    }
    if (accionNormalizada.includes("marcar_fallida_gesden")) {
      MessageService.alert(
        "Atención",
        "Recuerda cambiar el estado en GESDEN que esta accion tambien se ha realizado.",
        MessageService.TypeWarning,
      );
      return;
    }
    MessageService.alert(
      "Atención",
      "Recuerda cambiar el estado en GESDEN que esta accion tambien se ha realizado.",
      MessageService.TypeWarning,
    );
  }
  // --- Semaforo de colores (fuente única de verdad para icon + color + label) ---
  public stateInfo(codigo: string): { icon: string; vuetifyColor: string; hexColor: string; actionLabel: string } {
    const c = (codigo || "").toLowerCase();
    const map: Record<string, { icon: string; vuetifyColor: string; hexColor: string; actionLabel: string }> = {
      pendiente:                    { icon: "mdi-timer-sand",            vuetifyColor: "amber darken-2",        hexColor: "#F59E0B", actionLabel: "Reserva del paciente — pendiente de revisión" },
      en_revision:                  { icon: "mdi-eye-check",             vuetifyColor: "blue",                  hexColor: "#3B82F6", actionLabel: "" },
      confirmada:                   { icon: "mdi-check-circle",          vuetifyColor: "teal",                  hexColor: "#10B981", actionLabel: "" },
      enviada_gesden:               { icon: "mdi-send",                  vuetifyColor: "orange darken-2",       hexColor: "#F97316", actionLabel: "Enviada a GESDEN" },
      insertada_gesden:             { icon: "mdi-database-check",        vuetifyColor: "green darken-2",        hexColor: "#059669", actionLabel: "Confirmar cita" },
      cancelacion_pendiente_gesden: { icon: "mdi-calendar-remove",       vuetifyColor: "deep-orange darken-2",  hexColor: "#BF360C", actionLabel: "Cancelar en GESDEN" },
      reagendado_pendiente_gesden:  { icon: "mdi-calendar-arrow-right",  vuetifyColor: "amber darken-3",        hexColor: "#F9A825", actionLabel: "Mover en GESDEN" },
      confirmar_reagendado_gesden:  { icon: "mdi-calendar-check",        vuetifyColor: "teal darken-1",         hexColor: "#10B981", actionLabel: "✓ Moví en GESDEN" },
      conflicto:                    { icon: "mdi-alert-circle",          vuetifyColor: "red",                   hexColor: "#EF4444", actionLabel: "" },
      fallida_gesden:               { icon: "mdi-alert-circle",          vuetifyColor: "red",                   hexColor: "#EF4444", actionLabel: "" },
      cancelada:                    { icon: "mdi-cancel",                vuetifyColor: "grey darken-1",         hexColor: "#6B7280", actionLabel: "" },
      rechazada:                    { icon: "mdi-close-circle",          vuetifyColor: "grey darken-1",         hexColor: "#6B7280", actionLabel: "" },
      expirada:                     { icon: "mdi-timer-sand-empty",      vuetifyColor: "grey",                  hexColor: "#9CA3AF", actionLabel: "" },
    };
    return map[c] || { icon: "mdi-circle-medium", vuetifyColor: "grey", hexColor: "#9CA3AF", actionLabel: "" };
  }

  public stateColor(codigo: string): string {
    return this.stateInfo(codigo).hexColor;
  }

  private stateTextColor(codigo: string): string {
    return (codigo || "").toLowerCase() === "pendiente" ? "#1F2937" : "#ffffff";
  }
  // --- Labels y colores de acciones ---
  public accionLabel(accion: string): string {
    const etiquetas: Record<string, string> = {
      marcar_en_revision: "Poner en revisión",
      confirmar: "Confirmar",
      marcar_enviada_gesden: "Enviada a GESDEN",
      marcar_insertada_gesden: "Confirmar cita",
      cancelacion_pendiente_gesden: "Cancelar en GESDEN (pendiente)",
      reagendado_pendiente_gesden: "Reagendar en GESDEN (pendiente)",
      marcar_conflicto: "Marcar conflicto",
      marcar_fallida_gesden: "Fallida en GESDEN",
      rechazar: "Rechazar",
      cancelar: "Cancelar",
      expirar: "Expirar",
      confirmar_cancelacion_gesden: "✓ Cancelé en GESDEN",
      confirmar_reagendado_gesden: "✓ Moví en GESDEN",
      reactivar: "Reactivar",
    };
    return etiquetas[accion] || accion.replace(/_/g, " ");
  }

  public accionColor(accion: string): string {
    if (accion.includes("cancelacion_pendiente_gesden")) return "deep-orange";
    if (accion.includes("reagendado_pendiente_gesden")) return "amber darken-2";
    if (
      accion.includes("cancelar") ||
      accion.includes("rechazar") ||
      accion.includes("expirar")
    )
      return "red";
    if (accion.includes("conflicto") || accion.includes("fallida"))
      return "orange";
    if (accion.includes("confirmar") || accion.includes("insertada"))
      return "green";
    return "primary";
  }

  public accionIcon(accion: string): string {
    const iconos: Record<string, string> = {
      marcar_en_revision: "mdi-eye-check",
      confirmar: "mdi-check-circle",
      marcar_enviada_gesden: "mdi-send",
      marcar_insertada_gesden: "mdi-database-check",
      cancelacion_pendiente_gesden: "mdi-calendar-remove",
      reagendado_pendiente_gesden: "mdi-calendar-arrow-right",
      marcar_conflicto: "mdi-alert-circle",
      marcar_fallida_gesden: "mdi-alert-octagon",
      rechazar: "mdi-close-circle",
      cancelar: "mdi-cancel",
      expirar: "mdi-timer-sand-empty",
      confirmar_cancelacion_gesden: "mdi-check-decagram",
      confirmar_reagendado_gesden: "mdi-calendar-check",
      reactivar: "mdi-restore",
    };
    return iconos[accion] || "mdi-lightning-bolt";
  }
  // --- Utilidades ---
  private mapPaciente(p: any): any {
    const nombre = ((p.nombre || "") + " " + (p.apellidos || "")).trim();
    const tel = p.telefono ? " - " + p.telefono : "";
    return { id: p.id, label: nombre + tel };
  }

  private calcDuracion(): number {
    if (this.createForm.fecha_hora_inicio && this.createForm.fecha_hora_fin) {
      const s = new Date(this.createForm.fecha_hora_inicio).getTime();
      const e = new Date(this.createForm.fecha_hora_fin).getTime();
      if (e > s) return Math.round((e - s) / 60000);
    }
    const svc = (this.catalogos.servicios || []).find(
      (s: any) => s.id === this.createForm.id_servicio,
    );
    return svc && svc.tiempo_minutos ? svc.tiempo_minutos : 30;
  }

  public formatDateTime(value: any): string {
    if (!value) return "-";
    const d = new Date(value);
    if (isNaN(d.getTime())) return String(value);
    const dd = d
      .getDate()
      .toString()
      .padStart(2, "0");
    const mm = (d.getMonth() + 1).toString().padStart(2, "0");
    const yy = d.getFullYear();
    const hh = d
      .getHours()
      .toString()
      .padStart(2, "0");
    const mi = d
      .getMinutes()
      .toString()
      .padStart(2, "0");
    return dd + "/" + mm + "/" + yy + " " + hh + ":" + mi;
  }

  public formatFechaCorta(iso: string): string {
    if (!iso) return "";
    const d = new Date(iso);
    if (isNaN(d.getTime())) return iso.substring(0, 10);
    const dias = ["Dom", "Lun", "Mar", "Mie", "Jue", "Vie", "Sab"];
    const meses = [
      "ene",
      "feb",
      "mar",
      "abr",
      "may",
      "jun",
      "jul",
      "ago",
      "sep",
      "oct",
      "nov",
      "dic",
    ];
    return dias[d.getDay()] + " " + d.getDate() + " " + meses[d.getMonth()];
  }

  private async cargarDrawerForm() {
    const s = this.drawerSolicitud;
    if (!s || !s.id) {
      this.drawerForm = this.defaultDrawerForm();
      this.drawerPacienteBase = null;
      return;
    }

    let pacienteRaw: any = null;
    try {
      const pRes: any = await solicitudesWorkflowModule.getPacienteLead(
        Number(s.id_paciente_lead),
      );
      pacienteRaw = pRes && pRes.data ? pRes.data : null;
    } catch (e) {
      pacienteRaw = null;
    }
    this.drawerPacienteBase = pacienteRaw;

    const split = this.splitPacienteNombre(s.paciente_nombre || "");
    this.drawerForm = {
      id: s.id,
      id_paciente_lead: s.id_paciente_lead,
      nombre:
        pacienteRaw && pacienteRaw.nombre ? pacienteRaw.nombre : split.nombre,
      apellidos:
        pacienteRaw && pacienteRaw.apellidos
          ? pacienteRaw.apellidos
          : split.apellidos,
      telefono:
        pacienteRaw && pacienteRaw.telefono
          ? pacienteRaw.telefono
          : s.paciente_telefono || "",
      email:
        pacienteRaw && pacienteRaw.email
          ? pacienteRaw.email
          : s.paciente_email || "",
      documento:
        pacienteRaw && pacienteRaw.documento
          ? pacienteRaw.documento
          : s.paciente_documento || "",
      id_centro: s.id_centro || this.filters.id_centro || null,
      id_servicio: s.id_servicio || null,
      id_canal_entrada: s.id_canal_entrada || null,
      fecha_hora_inicio: this.toDateTimeLocal(s.fecha_hora_inicio_solicitada),
      fecha_hora_fin: this.toDateTimeLocal(s.fecha_hora_fin_solicitada),
      duracion_minutos: s.duracion_minutos || 30,
      motivo_paciente: s.motivo_paciente || "",
      notas_internas: s.notas_internas || "",
      observaciones_admin: s.observaciones_admin || "",
    };
  }

  private splitPacienteNombre(nombreCompleto: string): any {
    const parts = (nombreCompleto || "")
      .trim()
      .split(" ")
      .filter((x: string) => !!x);
    if (!parts.length) return { nombre: "", apellidos: "" };
    return {
      nombre: parts[0],
      apellidos: parts.slice(1).join(" "),
    };
  }

  private toIsoDate(value: string): string {
    const d = new Date(value);
    return isNaN(d.getTime()) ? value : d.toISOString();
  }

  private toDateTimeLocal(value: any): string {
    if (!value) return "";
    const d = new Date(value);
    if (isNaN(d.getTime())) return "";
    const yyyy = d
      .getFullYear()
      .toString()
      .padStart(4, "0");
    const mm = (d.getMonth() + 1).toString().padStart(2, "0");
    const dd = d
      .getDate()
      .toString()
      .padStart(2, "0");
    const hh = d
      .getHours()
      .toString()
      .padStart(2, "0");
    const mi = d
      .getMinutes()
      .toString()
      .padStart(2, "0");
    return yyyy + "-" + mm + "-" + dd + "T" + hh + ":" + mi;
  }

  private sumarMinutosIso(inicioIso: string, minutos: number): string {
    const d = new Date(inicioIso);
    if (isNaN(d.getTime())) return inicioIso;
    d.setMinutes(d.getMinutes() + (minutos || 30));
    return d.toISOString();
  }

  private timeSpanFromIso(iso: string): string {
    const d = new Date(iso);
    if (isNaN(d.getTime())) return "00:00:00";
    const hh = d
      .getHours()
      .toString()
      .padStart(2, "0");
    const mi = d
      .getMinutes()
      .toString()
      .padStart(2, "0");
    const ss = d
      .getSeconds()
      .toString()
      .padStart(2, "0");
    return hh + ":" + mi + ":" + ss;
  }

  private getSiguienteBloqueHorario(): Date {
    const now = new Date();
    const d = new Date(now);
    const mins = d.getMinutes();
    const rounded = mins < 30 ? 30 : 60;
    d.setMinutes(rounded, 0, 0);
    if (rounded === 60) {
      d.setHours(d.getHours() + 1, 0, 0, 0);
    }
    return d;
  }

  private _loadAddManualWarningPreference() {
    this.dontShowManualWarningAgain = this._shouldSkipAddManualWarning();
  }

  private _shouldSkipAddManualWarning(): boolean {
    return (
      localStorage.getItem(AgendaCalendarManager.ADD_MANUAL_WARNING_KEY) === "1"
    );
  }

  private defaultCreateForm(): any {
    return {
      id_paciente_lead: null,
      nombre: "",
      apellidos: "",
      telefono: "",
      email: "",
      id_servicio: null,
      canal_codigo: "telefono",
      fecha_hora_inicio: "",
      fecha_hora_fin: "",
      motivo_paciente: "",
      notas_internas: "",
    };
  }

  private defaultDrawerForm(): any {
    return {
      id: null,
      id_paciente_lead: null,
      nombre: "",
      apellidos: "",
      telefono: "",
      email: "",
      documento: "",
      id_centro: null,
      id_servicio: null,
      id_canal_entrada: null,
      fecha_hora_inicio: "",
      fecha_hora_fin: "",
      duracion_minutos: 30,
      motivo_paciente: "",
      notas_internas: "",
      observaciones_admin: "",
    };
  }
}
